<template>
  <div class="meeting-topics_wrapper">
    <div class="ql-editor ql-blank">
      <div class="ql-container" v-html="value" />
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  props: { value: {} },
}
</script>
<style lang="scss" scoped>
.meeting-topics_wrapper {
  overflow: auto;
  border-radius: 5px;
}
.ql-editor {
  padding-left: 0 !important;
  padding-top: 1px !important;
}
.ql-editor::-webkit-scrollbar-track {
  background: #eee; /* 滚动条轨道颜色 */
  border-radius: 5px; /* 滚动条轨道圆角 */
}
.ql-editor::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.ql-editor::-webkit-scrollbar-thumb {
  background: #ccc; /* 滚动条thumb颜色 */
  border-radius: 5px; /* 滚动条thumb圆角 */
}
</style>
